/**
 * PageMetaContext — 지금 화면의 메뉴 정보(이름·페이지 제목)를 레이아웃이 페이지에 내려준다.
 *
 * DESIGN-AI §19: 페이지 제목은 메뉴 관리(/settings/menus)의 "페이지 제목" 칸에서 정한다.
 * 비어 있으면 메뉴 이름. PageHeader 가 title 을 받지 않으면 여기서 읽는다.
 * 레이아웃(CRM·IT·설정)이 라우트로 찾은 메뉴 항목을 넣는다 — 못 찾으면 null(페이지가 직접 title 을 준다).
 */
import React from "react";

/** 상단 바 경로 한 칸 — 문자열(옛 방식, 링크 없음) 또는 갈 곳(to)이 있는 링크 칸. */
export type Crumb = string | { label: string; to?: string };

export type PageMeta = {
  /** 사이드바 메뉴 이름 */
  menuLabel: string;
  /** 페이지 헤더 제목 = 페이지 제목 오버라이드 || 메뉴 이름 */
  title: string;
  /** 상단 바 경로(DESIGN-AI §1) — [영역, 상위 메뉴(, 상세 화면이면 목록 메뉴)]. 페이지 이름은 넣지 않는다.
   *  각 칸에 to 를 주면 눌러서 그 화면으로 간다. */
  crumbs?: Crumb[];
  /** 사이드바 메뉴 아이콘(요소). PageHeader 가 icon 을 안 받으면 24px 로 키워 쓴다 — 메뉴 관리에서 바꾼 아이콘도 따라간다. */
  icon?: React.ReactNode;
};

const PageMetaContext = React.createContext<PageMeta | null>(null);

export const PageMetaProvider = PageMetaContext.Provider;

export function usePageMeta(): PageMeta | null {
  return React.useContext(PageMetaContext);
}

/** 오버라이드가 비었거나 공백이면 메뉴 이름 */
export function pageTitleOf(menuLabel: string, pageTitle?: string | null): string {
  const t = (pageTitle || "").trim();
  return t || menuLabel;
}
